var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShieldCheckered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9883 6.75H9.98828C8.99372 6.75 8.03989 7.14509 7.33663 7.84835C6.63337 8.55161 6.23828 9.50544 6.23828 10.5V21.5194C6.23828 38.8387 20.882 44.5819 23.8164 45.5531C24.1592 45.6669 24.5167 45.73 24.8777 45.7406C24.9152 45.7406 24.9508 45.7406 24.9883 45.7406C25.0258 45.7406 25.0614 45.7406 25.097 45.7406C25.458 45.7295 25.8154 45.6664 26.1583 45.5531C29.0945 44.5837 43.7383 38.8425 43.7383 21.5231V10.5C43.7383 9.50544 43.3432 8.55161 42.6399 7.84835C41.9367 7.14509 40.9828 6.75 39.9883 6.75ZM39.2383 21.5231C39.2383 21.6 39.2383 21.675 39.2383 21.75H27.2383V11.25H39.2383V21.5231ZM10.7383 11.25H22.7383V21.75H10.7383C10.7383 21.675 10.7383 21.6 10.7383 21.5231V11.25ZM11.2239 26.25H22.7383V40.26C19.0502 38.4769 12.9733 34.3819 11.2239 26.25ZM27.2383 40.26V26.25H38.7527C37.0033 34.3819 30.9264 38.4769 27.2383 40.26Z",
    fill: "url(#paint0_linear_1568_2186)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1568_2186",
    x1: 24.9883,
    y1: 6.75,
    x2: 24.9883,
    y2: 45.7406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheckered);
export default __webpack_public_path__ + "static/media/ShieldCheckered.236867a0fd21eff55d0a17c8622e656b.svg";
export { ForwardRef as ReactComponent };